<div class="row">
  <div class="col-md-8">
    <h1 class="mb-3">About</h1>
    <p>
      AboutComponent
    </p>
  </div>
</div>
